import { render, staticRenderFns } from "./addMechanism.vue?vue&type=template&id=23f2ca26&scoped=true"
import script from "./addMechanism.vue?vue&type=script&lang=js"
export * from "./addMechanism.vue?vue&type=script&lang=js"
import style0 from "./addMechanism.vue?vue&type=style&index=0&id=23f2ca26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f2ca26",
  null
  
)

export default component.exports